/**
 * A clock for drawing the visualizer's drift. While `isStill` returns true it
 * holds the time it stopped at, so a redraw for a resize or a theme change does
 * not move the paused plate. Time spent still is skipped, so the drift resumes
 * where it stopped instead of jumping ahead.
 */
export function createVisualizerMotionClock(isStill: () => boolean) {
  let stillTotalMs = 0
  let stillSince: number | null = null
  return () => {
    const now = performance.now()
    if (isStill()) {
      stillSince ??= now
      return stillSince - stillTotalMs
    }
    if (stillSince !== null) {
      stillTotalMs += now - stillSince
      stillSince = null
    }
    return now - stillTotalMs
  }
}
